<h2 mat-dialog-title>{{ "Importer til bibliotekmappen '{navn}'"|translate: {navn: mappe.navn} }}</h2>

@switch (modus()) {
  @case ('importer') {
    <mat-dialog-content class="importer">
      <div class="innhold">
        <p>
          @if (forStor) {
            {{ 'Filen er for stor og kan ikke importeres. Maksimal størrelse er {grense}'|translate: {grense: maksFilstoerrelse|filstoerrelse} }}
          } @else {
            {{ "Vil du importere arkivfilen '{filnavn}' og pakke denne ut i mappen '{mappe}'?"|translate: {filnavn: zipFil.name, mappe: mappe.navn} }}
          }
        </p>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
      <button mat-raised-button color="primary" cdkFocusInitial (click)="startImport()" data-testid="importer">
        {{ 'Importer'|translate }}
      </button>
    </mat-dialog-actions>
  }

  @case ('importerer') {
    <mat-dialog-content class="importerer">
      <div class="innhold">
        <h3>
          {{ "Importerer '{filnavn}' til mappen '{mappe}'."|translate: {filnavn: zipFil.name, mappe: mappe.navn} }}
        </h3>

        @if (progresjon() < 100) {
          <!-- mat-progress-spinner.value forventes å være et tall mellom 0 og 100 -->
          <mat-progress-spinner mode="determinate" [value]="progresjon()" diameter="50"/>
        } @else {
          <mat-progress-spinner mode="indeterminate" diameter="50"/>
          {{ 'Filen er lastet opp og pakkes ut...' }}
        }
        <!-- <div layout="row" layout-sm="column" layout-align="space-around">
           <md-progress-circular md-mode="determinate" value="{{$ctrl.opplasting.progresjon}}" ng-if="$ctrl.opplasting.progresjon < 100"></md-progress-circular>
           <md-progress-circular md-mode="indeterminate" ng-if="$ctrl.opplasting.progresjon >= 100"></md-progress-circular> &lt;!&ndash; når opplastingen er ferdig vil serveren fortsatt bruke tid på å pakke ut og lagre &ndash;&gt;
         </div>-->
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
    </mat-dialog-actions>
  }

  @case ('importert') {
    <mat-dialog-content class="importert">
      <div class="innhold">
        <h3>{{ 'Import utført'|translate }}</h3>
        <h4>{{ 'Følgende filer ble importert:'|translate }}</h4>
        @if (importresultat()!.importerteFiler.length == 0) {
          <p>{{ 'Ingen filer ble importert'|translate }}</p>
        }
        <ul>
          @for (fil of importresultat()!.importerteFiler; track fil) {
            <li>{{ fil }}</li>
          }
        </ul>
        @if (importresultat()!.filerSomBleIgnorert.length > 0) {
          <h4>{{ 'Følgende filer ble ignorert pga. filtype:'|translate }}</h4>
          <ul>
            @for (fil of importresultat()!.filerSomBleIgnorert; track fil) {
              <li>{{ fil }}</li>
            }
          </ul>
        }
        @if (importresultat()!.filerSomAlleredeEksisterte.length > 0) {
          <h4>{{ 'Følgende filer ble ignorert da de allerede eksisterer:'|translate }}</h4>
          <ul>
            @for (fil of importresultat()!.filerSomAlleredeEksisterte; track fil) {
              <li>{{ fil }}</li>
            }
          </ul>
        }
        @if (importresultat()!.filerSomVarForStore.length > 0) {
          <h4>{{ 'Følgende filer ble ignorert da de allerede eksisterer:'|translate }}</h4>
          <ul>
            @for (fil of importresultat()!.filerSomVarForStore; track fil) {
              <li>{{ fil }}</li>
            }
          </ul>
        }
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button type="button" (click)="lukk()">{{ "Lukk"|translate }}</button>
    </mat-dialog-actions>
  }

  @case ('feil') {
    <mat-dialog-content class="feilet">
      <p>{{ 'Import av "{zip}" til "{mappe}" feilet'|translate: {zip: zipFil.name, mappe: mappe.navn} }}</p>
      @for (feil of valideringsfeil!.feil; track feil.feilkode) {
        @switch (feil.feilkode) {
          @case (muligFeilkoder.maks_antallfiler_overskredet) {
            <div class="feil">
              <mat-icon>error</mat-icon>
              {{ 'Importen inneholder mer enn 10 nivåer med nestede kataloger'|translate }}
            </div>
          }
          @case (muligFeilkoder.maks_dybde_overskredet) {
            <div class="feil">
              <mat-icon>error</mat-icon>
              {{ 'Importen inneholder mer enn 1000 filer'|translate }}
            </div>
          }
        }
      }
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button type="button" (click)="avbryt()">{{ "Lukk"|translate }}</button>
    </mat-dialog-actions>
  }
}
